import type { Payment } from '@raisenow/epik';
import { defer, from, map } from 'rxjs';

export function validateEpikPayment(payment: Payment) {
  return defer(() => {
    // mark all fields in cc-iframe as touched
    // this must be run before payment.validate() if cc-iframe is used
    payment.markAllFieldsAsTouched();

    return from(payment.validate());
  });
}

/**
 * Validates the given `payment`.
 *
 * @param payment Payment object
 *
 * @returns
 * Emits `true`, when the payment is valid, otherwise `false`.
 * Then completes.
 */
export function epikPaymentValid(payment) {
  return validateEpikPayment(payment).pipe(map((errors) => errors === null));
}
